import * as AppLange from './src/App.lang'

export const Language = {
  ...AppLange,
}
